import { packageCancellationActionTypes } from './Constants';

export function getPackageCancellationDataRequest() {
	return {
		type: packageCancellationActionTypes.GET_PACKAGE_CANCELLATION_DATA_REQUEST,
	};
}

export function getPackageCancellationDataSuccess(data) {
	return {
		type: packageCancellationActionTypes.GET_PACKAGE_CANCELLATION_DATA_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getPackageCancellationDataError() {
	return {
		type: packageCancellationActionTypes.GET_PACKAGE_CANCELLATION_DATA_ERROR,
	};
}

export function setPackageCancellationData(data) {
	return {
		type: packageCancellationActionTypes.SET_PACKAGE_CANCELLATION_DATA,
		payload: {
			data,
		},
	};
}

export function applyOfferRequest(type, eventData) {
	return {
		type: packageCancellationActionTypes.APPLY_OFFER_REQUEST,
		payload: {
			type,
			eventData,
		},
	};
}

export function applyOfferSuccess(data) {
	return {
		type: packageCancellationActionTypes.APPLY_OFFER_SUCCESS,
		payload: {
			data,
		},
	};
}

export function applyOfferError() {
	return {
		type: packageCancellationActionTypes.APPLY_OFFER_ERROR,
	};
}

export function resetState() {
	return {
		type: packageCancellationActionTypes.RESET_STATE,
	};
}
